import { IField } from '../../../data-models/field2.data-model';
import { ColumnMeta } from '../../../types';
import { IFormulaFieldDataModel } from '../../../data-models/formula-field.data-model';
import { ColumnFieldModal, CustomFieldModal, KpiFieldModal } from './FieldFormModals';
import { FormulaFieldModal } from './FormulaFieldModal';
import { FieldKind } from './fieldManagerModels';

interface FieldEditModalProps {
  kind: FieldKind;
  item: unknown;
  onClose: () => void;
}

/** Opens the edit form for a row, using that field type's own schema-driven form. */
export function FieldEditModal({ kind, item, onClose }: FieldEditModalProps) {
  switch (kind) {
    case 'kpi':
      return <KpiFieldModal item={item as IField<unknown>} onClose={onClose} />;
    case 'custom':
      return <CustomFieldModal item={item as IField<unknown>} onClose={onClose} />;
    case 'column':
      return <ColumnFieldModal item={item as ColumnMeta} onClose={onClose} />;
    case 'formula':
      return <FormulaFieldModal item={item as IFormulaFieldDataModel} onClose={onClose} />;
    default:
      return null;
  }
}
